import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { MixpanelProvider } from "@/contexts/MixpanelProvider";
import { AuthProvider } from "@/hooks/AuthProvider";
import { ConfigProvider } from "@/hooks/useConfig";
import { useAuth } from "./hooks/useAuth";
import { queryClient } from "./lib/queryClient";
import { router } from "./lib/router";

export function App() {
  const auth = useAuth();

  return (
    <ConfigProvider>
      <MixpanelProvider>
        <RouterProvider router={router} context={{ auth }} />
      </MixpanelProvider>
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            richColors
            style={
              {
                "--width": "800px", // container width
              } as React.CSSProperties
            }
          />
        </AuthProvider>
      </TooltipProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
